// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".observationPhoto:hover {\n    transform: scale(1.2);\n    transition: transform 0.5s cubic-bezier(0.25, 0.45, 0.45, 0.95);\n}\n\n.selected {\n    border-width: 2px;\n    border-style: solid;\n    border-color: blue;\n}", ""]);
// Exports
module.exports = exports;
